<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center mb-2 px-3">
        <span class="col-auto">
          <h2 class="mb-0">
            Open Line's
            <jni-spinner *ngIf="showLoader"></jni-spinner>
          </h2>
        </span>

        <span class="col-auto">
          <div
            class="vendors-panel col-auto d-flex justify-content-between gap-2 align-items-center">
            <!-- <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <a class="link" (click)="exportExcel()"
                ><i class="pi pi-cloud-upload icon-blue mx-1"></i> Export
                excel</a
              >
            </div> -->

            <p-button
              label="Export Excel"
              variant="outlined"
              icon="pi pi-cloud-upload"
              severity="secondary"
              (click)="exportExcel()"
              class="fullwdth secondary-btn" />

            <p-button
              label="Add New Vendor"
              variant="outlined"
              icon="pi pi-plus"
              severity="secondary"
              (click)="onVendorRedirection()"
              class="fullwdth secondary-btn" />

            <span class="cross-border" (click)="onCloseModalEvent()"
              ><i class="pi pi-times"></i
            ></span>
            <!-- <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <a class="link" (click)="onVendorRedirection()">
                <i class="pi pi-plus"></i> Add New Vendor</a
              >
            </div> -->
          </div>
        </span>
      </span>

      <div class="col-12">
        <!-- <header
    class="vendors-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>Open Line's 2</h1>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showLoader">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="vendors-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="pi pi-cloud-upload icon-blue mx-1"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Add me-2"></i>
        <a class="link" (click)="onVendorRedirection()">Add New Vendor</a>
      </div>
    </div>
  </header> -->
        <p-table
          #dt
          stripedRows
          [rowHover]="true"
          [rows]="25"
          [showCurrentPageReport]="true"
          [scrollable]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [resizableColumns]="true"
          responsiveLayout="scroll"
          [value]="openPoLinesListings"
          [(selection)]="selectedVendors"
          styleClass="p-datatable-customers"
          [rowHover]="true"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [paginator]="false"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [filterDelay]="0"
          [paginator]="true"
          [rows]="30"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th>PO #</th>
              <th>Lines #</th>
              <th>Status</th>
              <th>Vendor Name</th>
              <th>Vendor SKU</th>
              <th class="max-width-10">Description</th>
              <th>Qty</th>
              <th>UOM</th>
              <th>Unmatch Quantity</th>
              <th>Net</th>
              <th>Net Total</th>
              <th>In Hands Date</th>
              <th>Tracking</th>
              <th>Category</th>
              <th>Date Created</th>
            </tr>
            <tr>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="poNumber"
                    id="poNumber"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'poNumber',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="lineNumber"
                    id="lineNumber"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'lineNumber',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="status"
                    id="status"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'status',
                        'startsWith'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-vendorListing
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="vendorListing"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  [disabled]="false"
                  [value]="vendorListing"
                  (click)="checkboxSelection()"></p-tableCheckbox>
              </td>
              <td (click)="getCurrentVendor(vendorListing.poNumber)">
                <a class="link">{{ vendorListing.poNumber }}</a>
              </td>
              <td>
                {{ vendorListing.lineNumber }}
              </td>
              <td>
                {{ vendorListing.status }}
              </td>
              <td>
                {{ vendorListing.vendorName }}
              </td>
              <td>
                {{ vendorListing.vendorSKU }}
              </td>
              <td class="max-width-10">
                <div
                  class="description-title"
                  [title]="vendorListing.description">
                  {{ vendorListing.description }}
                </div>
              </td>
              <td>
                {{ vendorListing.quantity }}
              </td>
              <td>
                {{ vendorListing.uOM }}
              </td>
              <td>
                {{ vendorListing.unmatchedQuantity }}
              </td>
              <td>
                {{ vendorListing.net | number: "1.2-2" }}
              </td>
              <td>
                {{ vendorListing.netTotal | number: "1.2-2" }}
              </td>
              <td>
                {{ vendorListing.inHandsDate | date: "MM-dd-yyyy" }}
              </td>
              <td>
                {{ vendorListing.tracking }}
              </td>
              <td>
                {{ vendorListing.category }}
              </td>
              <td>
                {{ vendorListing.dateCreated | date: "MM-dd-yyyy" }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No vendor found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>
